// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-details-send-message{padding-left:2px}.group-details-send-message__print-btn{z-index:104;float:right}.group-details-send-message__type-field{width:60%}.group-details-send-message__type-field .ui-form-field__error{display:none}", ""]);
// Exports
module.exports = exports;
